$(function () {

  let itemCount = $(".item-archive__item").length;


  let currentUrl = location.href;
  let preOrder = 'preorder';
  if (currentUrl.indexOf(preOrder) > -1) {
    $('#preorder-btn').addClass('current');
  }

  let urlParam = location.search.substring(1);

  if (urlParam) {
    let param = urlParam.split('&');
    let paramArray = [];
    for (i = 0; i < param.length; i++) {
      let paramItem = param[i].split('=');
      paramArray[paramItem[0]] = paramItem[1];
    }

    if (paramArray.category) {
      for (let i = 1; i <= itemCount; i++) {
        if ($("#item-" + i + " ." + paramArray.category).length == 0) {
          $("#item-" + i).remove();
        }
      }
      $(".color-form").prepend('<input type="hidden" name="category" value="' + paramArray.category + '">');
      $(".price_conditions").prepend('<input type="hidden" name="category" value="' + paramArray.category + '">');
      $(".stock-form").prepend('<input type="hidden" name="category" value="' + paramArray.category + '">');
      $(".sort_by").prepend('<input type="hidden" name="category" value="' + paramArray.category + '">');
      $("#sp-value-category").val(paramArray.category);

      if (
        paramArray.category === "coat" ||
        paramArray.category === "blouson-jacket" ||
        paramArray.category === "vest"
      ) {
        $("#tab-cat-outer").addClass("current");
        $("#collection-breadcrumb").before('<a href="/collections/outer/">Outer</a><p>＞</p>');
        if (paramArray.category === "coat") {
          $("#current-item").text("Coat");
          $("#collection-breadcrumb").text("Coat");
        } else if (paramArray.category === "blouson-jacket") {
          $("#current-item").text("Blouson / Jacket");
          $("#collection-breadcrumb").text("Blouson / Jacket");
        } else if (paramArray.category === "vest") {
          $("#current-item").text("Vest");
          $("#collection-breadcrumb").text("Vest");
        }
      } else if (
        paramArray.category === "blouse-shirt" ||
        paramArray.category === "tunic" ||
        paramArray.category === "cut-sew-t-shirt" ||
        paramArray.category === "knit" ||
        paramArray.category === "cardigan" ||
        paramArray.category === "inner"
      ) {
        $("#tab-cat-tops").addClass("current");
        $("#collection-breadcrumb").before('<a href="/collections/tops/">Tops</a><p>＞</p>');
        if (paramArray.category === "blouse-shirt") {
          $("#current-item").text("Blouse / Shirt");
          $("#collection-breadcrumb").text("Blouse / Shirt");
        } else if (paramArray.category === "tunic") {
          $("#current-item").text("Tunic");
          $("#collection-breadcrumb").text("Tunic");
        } else if (paramArray.category === "cut-sew-t-shirt") {
          $("#current-item").text("Cut sew / T-shirt");
          $("#collection-breadcrumb").text("Cut sew / T-shirt");
        } else if (paramArray.category === "knit") {
          $("#current-item").text("Knit");
          $("#collection-breadcrumb").text("Knit");
        } else if (paramArray.category === "cardigan") {
          $("#current-item").text("Cardigan");
          $("#collection-breadcrumb").text("Cardigan");
        } else if (paramArray.category === "inner") {
          $("#current-item").text("Inner");
          $("#collection-breadcrumb").text("Inner");
        }
      } else if (
        paramArray.category === "one-piece" ||
        paramArray.category === "all-in-one"
      ) {
        $("#tab-cat-dress").addClass("current");
        $("#collection-breadcrumb").before('<a href="/collections/dress/">One piece</a><p>＞</p>');
        if (paramArray.category === "one-piece") {
          $("#current-item").text("One piece");
          $("#collection-breadcrumb").text("One piece");
        } else if (paramArray.category === "all-in-one") {
          $("#current-item").text("All in one");
          $("#collection-breadcrumb").text("All in one");
        }
      } else if (
        paramArray.category === "pants" ||
        paramArray.category === "skirt"
      ) {
        $("#tab-cat-bottoms").addClass("current");
        $("#collection-breadcrumb").before('<a href="/collections/bottoms/">Bottoms</a><p>＞</p>');
        if (paramArray.category === "pants") {
          $("#current-item").text("Pants");
          $("#collection-breadcrumb").text("Pants");
        } else if (paramArray.category === "skirt") {
          $("#current-item").text("Skirt");
          $("#collection-breadcrumb").text("Skirt");
        }
      } else if (paramArray.category === "outer") {
        $("#tab-cat-outer").addClass("current");
        $("#current-item").text("Outer");
        $("#collection-breadcrumb").text("Outer");
      } else if (paramArray.category === "tops") {
        $("#tab-cat-tops").addClass("current");
        $("#current-item").text("Tops");
        $("#collection-breadcrumb").text("Tops");
      } else if (paramArray.category === "dress") {
        $("#tab-cat-dress").addClass("current");
        $("#current-item").text("One piece");
        $("#collection-breadcrumb").text("One piece");
      } else if (paramArray.category === "bottoms") {
        $("#tab-cat-bottoms").addClass("current");
        $("#current-item").text("Bottoms");
        $("#collection-breadcrumb").text("Bottoms");
      } else if (paramArray.category === "other") {
        $("#tab-cat-other").addClass("current");
        $("#current-item").text("Other");
        $("#collection-breadcrumb").text("Other");
      }
    }

    if (paramArray.color) {
      for (let i = 1; i <= itemCount; i++) {
        if ($("#item-" + i + " ." + paramArray.color).length == 0) {
          $("#item-" + i).remove();
        }
      }
      $(".category-form").prepend('<input type="hidden" name="color" value="' + paramArray.color + '">');
      $(".price_conditions").prepend('<input type="hidden" name="color" value="' + paramArray.color + '">');
      $(".stock-form").prepend('<input type="hidden" name="color" value="' + paramArray.color + '">');
      $(".sort_by").prepend('<input type="hidden" name="color" value="' + paramArray.color + '">');
      $("#sp-value-color").val(paramArray.color);
    }

    if (paramArray.stock) {
      if (paramArray.stock === "in-stock") {
        for (let i = 1; i <= itemCount; i++) {
          if ($("#item-" + i + " ." + paramArray.stock).length == 0) {
            $("#item-" + i).remove();
          }
        }
        $(".color-form").prepend('<input type="hidden" name="stock" value="' + paramArray.stock + '">');
        $(".category-form").prepend('<input type="hidden" name="stock" value="' + paramArray.stock + '">');
        $(".price_conditions").prepend('<input type="hidden" name="stock" value="' + paramArray.stock + '">');
        $(".sort_by").prepend('<input type="hidden" name="stock" value="' + paramArray.stock + '">');
        $("#sp-form").prepend('<input type="hidden" name="stock" value="' + paramArray.stock + '">');
        $("#sort-current-2 span").text("在庫あり");
      }
    }

    if (paramArray.sort_by) {
      $(".color-form").prepend('<input type="hidden" name="sort_by" value="' + paramArray.sort_by + '">');
      $(".category-form").prepend('<input type="hidden" name="sort_by" value="' + paramArray.sort_by + '">');
      $(".price_conditions").prepend('<input type="hidden" name="sort_by" value="' + paramArray.sort_by + '">');
      $(".stock-form").prepend('<input type="hidden" name="sort_by" value="' + paramArray.sort_by + '">');
      $("#sp-form").prepend('<input type="hidden" name="sort_by" value="' + paramArray.sort_by + '">');
      if (paramArray.sort_by == "price-ascending") $("#sort-current span").text("価格の低い順");
      if (paramArray.sort_by == "price-descending") $("#sort-current span").text("価格の高い順");
      if (paramArray.sort_by == "best-selling") $("#sort-current span").text("人気順");
    }

    if (paramArray.price_conditions) {
      if (paramArray.price_conditions === "sale") {
        for (let i = 1; i <= itemCount; i++) {
          if ($("#item-" + i + " .sale").length == 0) {
            $("#item-" + i).remove();
          }
        }
        $("#tab-price-sale").addClass("current");
        $("#current-item").text("セール商品");
        if (paramArray.category) {
          $("#collection-breadcrumb").after('<p>＞</p><p>セール商品</p>');
          if (paramArray.category === "coat") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=coat">Coat</a>');
          } else if (paramArray.category === "blouson-jacket") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=blouson-jacket">Blouson / Jacket</a>');
          } else if (paramArray.category === "vest") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=vest">Vest</a>');
          } else if (paramArray.category === "blouse-shirt") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=blouse-shirt">Blouse / Shirt</a>');
          } else if (paramArray.category === "cut-sew-t-shirt") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=cut-sew-t-shirt">Cut sew / T-shirt</a>');
          } else if (paramArray.category === "knit") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=knit">Knit</a>');
          } else if (paramArray.category === "cardigan") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=cardigan">Cardigan</a>');
          } else if (paramArray.category === "one-piece") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=one-piece">One piece</a>');
          } else if (paramArray.category === "all-in-one") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=all-in-one">All in one</a>');
          } else if (paramArray.category === "tunic") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=tunic">Tunic</a>');
          } else if (paramArray.category === "pants") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=pants">Pants</a>');
          } else if (paramArray.category === "skirt") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=skirt">Skirt</a>');
          } else if (paramArray.category === "inner") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=inner">Inner</a>');
          } else if (paramArray.category === "dress") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=dress">One piece</a>');
          } else if (paramArray.category === "outer") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=outer">Outer</a>');
          } else if (paramArray.category === "tops") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=tops">Tops</a>');
          } else if (paramArray.category === "bottoms") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=bottoms">Bottoms</a>');
          } else if (paramArray.category === "other") {
            $("#collection-breadcrumb").html('<a href="/collections/all/?category=other">Other</a>');
          }
        } else {
          $("#collection-breadcrumb").text("セール商品");
        }

      } else {
        for (let i = 1; i <= itemCount; i++) {
          if ($("#item-" + i + " .sale").length != 0) {
            $("#item-" + i).remove();
          }
        }
        $("#tab-price-normal").addClass("current");
        $("#current-item").text("通常商品");
        $("#collection-breadcrumb").text("通常商品");
      }
      $(".color-form").prepend('<input type="hidden" name="price_conditions" value="' + paramArray.price_conditions + '">');
      $(".category-form").prepend('<input type="hidden" name="price_conditions" value="' + paramArray.price_conditions + '">');
      $(".stock-form").prepend('<input type="hidden" name="price_conditions" value="' + paramArray.price_conditions + '">');
      $(".sort_by").prepend('<input type="hidden" name="price_conditions" value="' + paramArray.price_conditions + '">');
      $("#sp-value-price").val(paramArray.price_conditions);
    }


    if (paramArray.select_low_price) {
      for (let i = 1; i <= itemCount; i++) {
        if (Number(paramArray.select_low_price) > Number($("#price-" + i).text().replace(",", "").replace("¥", ""))) {
          $("#item-" + i).remove();
        }
      }
      $(".color-form").prepend('<input type="hidden" name="select_low_price" value="' + paramArray.select_low_price + '">');
      $(".category-form").prepend('<input type="hidden" name="select_low_price" value="' + paramArray.select_low_price + '">');
      $(".stock-form").prepend('<input type="hidden" name="select_low_price" value="' + paramArray.select_low_price + '">');
      $(".sort_by").prepend('<input type="hidden" name="select_low_price" value="' + paramArray.select_low_price + '">');
      $(".price_conditions").prepend('<input type="hidden" name="select_low_price" value="' + paramArray.select_low_price + '">');
      $("#sp-form").prepend('<input type="hidden" name="select_low_price" value="' + paramArray.select_low_price + '">');
    }

    if (paramArray.select_high_price) {
      for (let i = 1; i <= itemCount; i++) {
        if (Number(paramArray.select_high_price) <= Number($("#price-" + i).text().replace(",", "").replace("¥", ""))) {
          $("#item-" + i).remove();
        }
      }
      $(".color-form").prepend('<input type="hidden" name="select_high_price" value="' + paramArray.select_high_price + '">');
      $(".category-form").prepend('<input type="hidden" name="select_high_price" value="' + paramArray.select_high_price + '">');
      $(".stock-form").prepend('<input type="hidden" name="select_high_price" value="' + paramArray.select_high_price + '">');
      $(".sort_by").prepend('<input type="hidden" name="select_high_price" value="' + paramArray.select_high_price + '">');
      $(".price_conditions").prepend('<input type="hidden" name="select_high_price" value="' + paramArray.select_high_price + '">');
      $("#sp-form").prepend('<input type="hidden" name="select_high_price" value="' + paramArray.select_high_price + '">');
    }

    if (paramArray.select_category) {
      console.log(paramArray.select_category);
      for (let i = 1; i <= itemCount; i++) {
        if ($("#category-" + i + " ." + paramArray.select_category).length == 0) {
          $("#item-" + i).remove();
        }
      }
      $("#breadcrumb-search").hide();
      $(".color-form").prepend('<input type="hidden" name="select_category" value="' + paramArray.select_category + '">');
      $(".category-form").prepend('<input type="hidden" name="select_category" value="' + paramArray.select_category + '">');
      $(".stock-form").prepend('<input type="hidden" name="select_category" value="' + paramArray.select_category + '">');
      $(".sort_by").prepend('<input type="hidden" name="select_category" value="' + paramArray.select_category + '">');
      $(".price_conditions").prepend('<input type="hidden" name="select_category" value="' + paramArray.select_category + '">');
      $("#sp-form").prepend('<input type="hidden" name="select_category" value="' + paramArray.select_category + '">');

      if (
        paramArray.select_category === "265652797530" ||
        paramArray.select_category === "265652830298" ||
        paramArray.select_category === "265652863066"
      ) {
        $("#collection-breadcrumb").before('<a href="/collections/outer/">Outer</a><p>＞</p>');
        $("#tab-cat-outer").addClass("current");
        if (paramArray.select_category === "265652797530") {
          $("#current-item").text("Coat");
          $("#collection-breadcrumb").text("Coat");
        } else if (paramArray.select_category === "265652830298") {
          $("#current-item").text("Blouson / Jacket");
          $("#collection-breadcrumb").text("Blouson / Jacket");
        } else if (paramArray.select_category === "265652863066") {
          $("#current-item").text("Vest");
          $("#collection-breadcrumb").text("Vest");
        }
      } else if (
        paramArray.select_category === "265652928602" ||
        paramArray.select_category === "265652961370" ||
        paramArray.select_category === "265652994138" ||
        paramArray.select_category === "265653026906" ||
        paramArray.select_category === "265653157978" ||
        paramArray.select_category === "266021208154" ||
        paramArray.select_category === "265653059674"
      ) {
        $("#collection-breadcrumb").before('<a href="/collections/tops/">Tops</a><p>＞</p>');
        $("#tab-cat-tops").addClass("current");
        if (paramArray.select_category === "265652928602") {
          $("#current-item").text("Blouse / Shirt");
          $("#collection-breadcrumb").text("Blouse / Shirt");
        } else if (paramArray.select_category === "265652961370") {
          $("#current-item").text("Cut sew / T-shirt");
          $("#collection-breadcrumb").text("Cut sew / T-shirt");
        } else if (paramArray.select_category === "265652994138") {
          $("#current-item").text("Parker");
          $("#collection-breadcrumb").text("Parker");
        } else if (paramArray.select_category === "265653026906") {
          $("#current-item").text("Knit");
          $("#collection-breadcrumb").text("Knit");
        } else if (paramArray.select_category === "265653059674") {
          $("#current-item").text("Cardigan");
          $("#collection-breadcrumb").text("Cardigan");
        } else if (paramArray.select_category === "265653157978") {
          $("#current-item").text("Tunic");
          $("#collection-breadcrumb").text("Tunic");
        } else if (paramArray.select_category === "266021208154") {
          $("#current-item").text("Inner");
          $("#collection-breadcrumb").text("Inner");
        }
      } else if (
        paramArray.select_category === "265653092442" ||
        paramArray.select_category === "265653125210"
      ) {
        $("#collection-breadcrumb").before('<a href="/collections/dress/">One piece</a><p>＞</p>');
        $("#tab-cat-dress").addClass("current");
        if (paramArray.select_category === "265653092442") {
          $("#current-item").text("One piece");
          $("#collection-breadcrumb").text("One piece");
        } else if (paramArray.select_category === "265653125210") {
          $("#current-item").text("All in one");
          $("#collection-breadcrumb").text("All in one");
        }
      } else if (
        paramArray.select_category === "265653190746" ||
        paramArray.select_category === "265653223514"
      ) {
        $("#collection-breadcrumb").before('<a href="/collections/bottoms/">Bottoms</a><p>＞</p>');
        $("#tab-cat-bottoms").addClass("current");
        if (paramArray.select_category === "265653190746") {
          $("#current-item").text("Pants");
          $("#collection-breadcrumb").text("Pants");
        } else if (paramArray.select_category === "265653223514") {
          $("#current-item").text("Skirt");
          $("#collection-breadcrumb").text("Skirt");
        }
      } else if (paramArray.select_category === "266021797978") {
        $("#collection-breadcrumb").before('<a href="/collections/other/">Other</a><p>＞</p>');
        $("#tab-cat-other").addClass("current");
      }
    }

    if (paramArray.select_size) {
      console.log();
      if (paramArray.select_size === "36size") {
        for (let i = 1; i <= itemCount; i++) {
          if ($("#size-" + i + " .36サイズ").length == 0) {
            $("#item-" + i).remove();
          }
        }
      } else if (paramArray.select_size === "38size") {
        if ($("#size-" + i + " .38サイズ").length == 0) {
          $("#item-" + i).remove();
        }
      }
      $(".color-form").prepend('<input type="hidden" name="select_size" value="' + paramArray.select_size + '">');
      $(".category-form").prepend('<input type="hidden" name="select_size" value="' + paramArray.select_size + '">');
      $(".stock-form").prepend('<input type="hidden" name="select_size" value="' + paramArray.select_size + '">');
      $(".sort_by").prepend('<input type="hidden" name="select_size" value="' + paramArray.select_size + '">');
      $(".price_conditions").prepend('<input type="hidden" name="select_size" value="' + paramArray.select_size + '">');
      $("#sp-form").prepend('<input type="hidden" name="select_size" value="' + paramArray.select_size + '">');
    }
    if (paramArray.q) {
      $(".color-form").prepend('<input type="hidden" name="q" value="' + decodeURI(paramArray.q) + '">');
      $(".category-form").prepend('<input type="hidden" name="q" value="' + decodeURI(paramArray.q) + '">');
      $(".stock-form").prepend('<input type="hidden" name="q" value="' + decodeURI(paramArray.q) + '">');
      $(".sort_by").prepend('<input type="hidden" name="q" value="' + decodeURI(paramArray.q) + '">');
      $(".price_conditions").prepend('<input type="hidden" name="q" value="' + decodeURI(paramArray.q) + '">');
      $("#sp-form").prepend('<input type="hidden" name="q" value="' + decodeURI(paramArray.q) + '">');
    }
  } else {
    let pathName = location.pathname;
    if (pathName === "/collections/ranking/") {
      $("#current-item").text("ランキング");
      $("#collection-breadcrumb").text("ランキング");
    } else if (pathName === "/collections/preorder/") {
      $("#current-item").text("23冬 PREORDER 【予約期間】10/16 10:00~10/23 11:59");
      $("#collection-breadcrumb").text("23冬PREORDER 【予約期間】10/16 10:00~10/23 11:59");
    } else if (pathName === "/collections/event/") {
      $("#current-item").text("POPUP 先行販売商品 ");
      $("#collection-breadcrumb").text("POPUP 先行販売商品");
    } else {
      $("#tab-price-all").addClass("current");
      $("#current-item").text("すべての商品");
      $("#collection-breadcrumb").text("すべての商品");
    }
  }

  $(".category-all").click(function () {
    $(".item-side--sp .item-category-sp").css("background-color", "transparent");
    $(this).css("background-color", "#f4f4f4");
    $("#sp-value-category").val("");
  });

  $("#Preorder").click(function () {
    $(".item-side--sp .item-category-sp").css("background-color", "transparent");
  });

  $(".item-side--sp .item-category-sp p").click(function () {
    $(".category-all").css("background-color", "transparent");
    $(".item-side--sp .item-category-sp p").css("background-color", "transparent");
    $(".item-category-btn").css("background-color", "transparent");

    if ($(this).parent().hasClass("item-category-btn")) {
      $(this).parent().css("background-color", "#f4f4f4");
    } else {
      $(this).css("background-color", "#f4f4f4");
    }

    if ($(this).attr('id') === 'Preorder') {
      $("#sp-form").attr('action', '/collections/preorder/');
      $("#sp-value-category").val('');
    } else {
      $('#Preorder').parent().css("background-color", "transparent");
      $("#sp-form").attr('action', '/collections/all/');
      $("#sp-value-category").val($(this).attr('id'));
    }

  });

  $(".item-side__text-other").click(function () {
    $(".item-side--sp .item-side__text-other").css("background-color", "transparent");
    $(this).css("background-color", "#f4f4f4");
    $("#sp-value-price").val($(this).children("span").attr('id'));
    if ($(this).children("span").attr('id') == 'sale') {
      $("#sp-form").attr('action', '/collections/all/');
    }

  });

  $(".item-side__color-box").click(function () {
    $(".item-side--sp .item-side__color-box").css("background-color", "transparent");
    $(this).css("background-color", "#f4f4f4");
    $("#sp-value-color").val($(this).find("span").attr('id'));
  });

  itemCount = $(".item-archive__item").length;
  if (itemCount) {
    $('.item-archive__box').paginathing({
      perPage: 30,
      prevText: '<',
      nextText: '>',
      activeClass: 'navi-active',
    });

    $(".total_item_count").text(itemCount);
    let endCount = Number($(".navi-active a").text()) * 30;
    $(".item_count_end").text(endCount);
    $(".item_count_start").text(endCount - 29);
    $(".pagination").before($(".item-archive__nav").html());
    $(".pagination-container").next().hide();
    if (itemCount < endCount) {
      $(".item_count_end").text(itemCount);
    }

    if ($(".page").length > 6) {
      $(".page").hide();
      $(".navi-active").show();
      $(".navi-active").prev().show().prev().show();
      $(".navi-active").next().show().next().show();
      if (!$(".navi-active").prev().hasClass("page")) {
        $(".page").hide();
        $(".prev").hide();
        $(".navi-active").show();
        $(".navi-active").next().show().next().show().next().show().next().show();
      }
      if (!$(".navi-active").prev().prev().hasClass("page") && $(".navi-active").prev().hasClass("page")) {
        $(".page").hide();
        $(".navi-active").show();
        $(".navi-active").prev().show();
        $(".navi-active").next().show().next().show().next().show();
      }
      if (!$(".navi-active").next().hasClass("page")) {
        $(".page").hide();
        $(".next").hide();
        $(".navi-active").show();
        $(".navi-active").prev().show().prev().show().prev().show().prev().show();
        console.log("3");
      }
      if (!$(".navi-active").next().next().hasClass("page") && $(".navi-active").next().hasClass("page")) {
        $(".page").hide();
        $(".navi-active").show();
        $(".navi-active").next().show();
        $(".navi-active").prev().show().prev().show().prev().show();
      }
    }
  } else {
    $(".result").text("条件に当てはまる商品がありません。");
    $(".item-archive__nav-left").text("");
  }
  $('.pagination .prev').hide()

  $(".item-list--large").click(function () {
    $(".item-archive__wrap").removeClass("archive-small");
    $(".item-list--large").addClass("item-list--current");
    $(".item-list--small").removeClass("item-list--current");
    $(".release-date").css("font-size", "12px");
    $(".release-date-text").css("font-size", "12px");
    $(".item-archive__item-name--small").hide();
    $(".item-archive__item-name").show();
  });
  $(".item-list--small").click(function () {
    $(".item-archive__wrap").addClass("archive-small");
    $(".item-list--large").removeClass("item-list--current");
    $(".item-list--small").addClass("item-list--current");
    $(".item-archive__item-name--small").show();
    $(".release-date").css("font-size", "10px");
    $(".release-date-text").css("font-size", "10px");
    $(".item-archive__item-name").hide();
  });
});